import React from "react";
import './index.css';

const polarToCartesian = (centerX: number, centerY: number, radius: number, angleInDegrees: number): { x: number; y: number; } => {
	let angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

	return {
		x: centerX + (radius * Math.cos(angleInRadians)),
		y: centerY + (radius * Math.sin(angleInRadians))
	};
}

const describeArc = (x: number, y: number, radius: number, startAngle: number, endAngle: number): string => {

	let start = polarToCartesian(x, y, radius, endAngle);
	let end = polarToCartesian(x, y, radius, startAngle);

	let largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

	let d = [
		"M", start.x, start.y,
		"A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
	].join(" ");

	return d;
}


export const WaitingWheel = ({
	error = false,
	timeout = false,
	className = '',
	color = '',
	timeoutColor = "#18f",
	ray = 20,
	strokeWidth = 4
}: {
	error?: boolean;
	timeout?: boolean;
	className?: string;
	color?: string;
	timeoutColor?: string;
	ray?: number;
	strokeWidth?: number;
}) => (
	<svg
		width={`${ ray + strokeWidth +1 }px`}
		height={`${ ray + strokeWidth +1 }px`}
		viewBox={`0 0 ${ 2 * ( ray + strokeWidth +1 ) } ${ 2 * ( ray + strokeWidth +1 ) }`}
		className={'status-in-wait ' + className }
	>
		{
			(!error && !timeout /*&& !props.done*/)
				? (
					<path
						d={describeArc(( ray + strokeWidth +1) || 20, (ray + strokeWidth +1) || 20, ray || 16, 0, 280)}
						// strokeMiterlimit={}
						strokeLinecap={"round"}
						stroke={ !!color ? color : "#fff"}
						strokeWidth={ strokeWidth || "4" }
						fill="#fff0"
					/>
				)
				: (
					<circle
						cx={ ( ray + strokeWidth +1) || 20 }
						cy={ ( ray + strokeWidth +1) || 20 }
						r={ ray || 16 }
						stroke={
							!!error
								? "#f35"
								: (
									!!timeout
										? timeoutColor
										: "#1f3"
								)
						}
						strokeWidth={ strokeWidth || "4"}
						fill="transparent"
					/>
				)
		}
	</svg>
)
